import { updateObject } from 'shared/utility';
import * as actionTypes from 'store/actions/actionTypes';

const initialState = {
  Posts: {
    Posts: [],
    PostLimit: null,
    PostCount: null,
    Page: null,
    filterTagUpdated: false,
  },
  loading: false,
  error: false,
};

const fetchGroupPostsListStart = (state) => {
  return {
    loading: true,
    error: false,
    Posts: {
      ...state.Posts,
      filterTagUpdated: false,
    },
  };
};

const fetchLogSuccess = (state, action) => {
  return updateObject(state, {
    GroupId: action.GroupId,
    Posts: {
      ...state.Posts,
      Posts: action.Posts,
      PostLimit: action.PostLimit,
      PostCount: action.PostCount,
      Page: action.Page,
      filterTagUpdated: !!action.Tag,
    },
    loading: false,
    error: null,
  });
};

const fetchLogFailed = (state, action) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_GROUP_POSTS_LIST_START:
      return fetchGroupPostsListStart(state, action);
    case actionTypes.FETCH_GROUP_POSTS_LIST_SUCCESS:
      return fetchLogSuccess(state, action);
    case actionTypes.FETCH_GROUP_POSTS_LIST_FAILED:
      return fetchLogFailed(state, action);
    default:
      return state;
  }
};
export default reducer;
